<div
    class="bg-slate-800 bg-opacity-50 dark:bg-opacity-70 flex justify-center items-center fixed top-0 right-0 bottom-0 left-0 z-50">
    <div
        class="bg-gradient-to-bl bg-dark-khaki-50 dark:bg-vivid-royal-950 px-16 py-14 w-full md:max-w-md rounded-2xl text-center relative"(appOutsideClick)="clickOutside($event)">
        @if (showIcon) {


        <h1 class="text-xl mx-auto text-center mb-5"
            [ngClass]="{'text-green':isSuccess,'dark:text-red-400 text-red-400':!isSuccess}">
            @if(isSuccess){
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-12 h-12 mx-auto"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><path d="m9 11 3 3L22 4"/></svg>
            }@else {
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-12 h-12 mx-auto"><circle cx="12" cy="12" r="10"/><line x1="12" x2="12" y1="8" y2="12"/><line x1="12" x2="12.01" y1="16" y2="16"/></svg>
            }


        </h1>
        }

        @if(isHtml){
        <p [innerHTML]="message | parserHtml " class="text-lg mb-4 font-medium text-medium_purple dark:text-dark-khaki-50">
        </p>
        }@else{
        <p class="text-lg mb-4 font-medium text-medium_purple dark:text-dark-khaki-50"> {{message}}</p>
        }
        @if(!isResponse){
            <div class="justify-items-start items-start">
                <h1 class="text-start  text-md  text-medium_purple dark:text-orange_light font-bold">
                    Entrega de dispositivos:
                </h1>
                <div class="block">
                    <div class=" flex justify-start">
                        <div class="inline-flex items-center">
                            <label class="relative flex cursor-pointer items-center rounded-full px-3 py-2" for="recoleccion"
                                data-ripple-dark="true">
                                <input id="recoleccion" type="radio" name="shipMethod" value="2" [(ngModel)]="deliveryMethod"
                                    class="before:content[''] peer relative h-5 w-5 cursor-pointer appearance-none rounded-md border border-dark_purple dark:border-dark-khaki-50 transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-12 before:w-12 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-blue-gray-500 before:opacity-0 before:transition-opacity checked:border-orange_light checked:bg-orange_light checked:before:bg-orange hover:before:opacity-10" />
                                <div
                                    class="pointer-events-none absolute top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 text-dark_purple opacity-0 transition-opacity peer-checked:opacity-100">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-3.5 w-3.5" viewBox="0 0 20 20"
                                        fill="currentColor" stroke="currentColor" stroke-width="1">
                                        <path fill-rule="evenodd"
                                            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                            clip-rule="evenodd"></path>
                                    </svg>
                                </div>
                            </label>
                            <label class="mt-px cursor-pointer select-none font-light dark:text-dark-khaki-50 text-dark_purple"
                                for="recoleccion">
                                Recolección en oficinas
                            </label>
                        </div>
                    </div>
                    <div class=" flex justify-start">
                        <div class="inline-flex items-center">
                            <label class="relative flex cursor-pointer items-center rounded-full px-3 py-2" for="envio"
                                data-ripple-dark="true">
                                <input id="envio" type="radio" name="shipMethod" value="1" [(ngModel)]="deliveryMethod"
                                    class="before:content[''] peer relative h-5 w-5 cursor-pointer appearance-none rounded-md border border-dark_purple dark:border-dark-khaki-50 transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-12 before:w-12 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-blue-gray-500 before:opacity-0 before:transition-opacity checked:border-orange_light checked:bg-orange_light checked:before:bg-orange hover:before:opacity-10" />
                                <div
                                    class="pointer-events-none absolute top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 text-dark_purple opacity-0 transition-opacity peer-checked:opacity-100">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-3.5 w-3.5" viewBox="0 0 20 20"
                                        fill="currentColor" stroke="currentColor" stroke-width="1">
                                        <path fill-rule="evenodd"
                                            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                            clip-rule="evenodd"></path>
                                    </svg>
                                </div>
                            </label>
                            <label class="mt-px cursor-pointer select-none font-light dark:text-dark-khaki-50 text-dark_purple"
                                for="envio">
                                Envío a domicilio fiscal
                            </label>
                        </div>
                    </div>
                </div>
               
                
                
            </div>
        }
      

        @if(hasButtons){
        <div class="flex justify-between">
            <button
                class="px-3 py-1 bg-orange_light text-medium_purple  rounded-md w-full sm:w-auto text-sm font-semibold disabled:bg-zinc-400 disabled:text-zinc-800/60"
                type="button" (click)="cancelAction()">{{txtCancelButton}}</button>
            <button
                class="px-3 py-1 bg-orange_light text-medium_purple  rounded-md w-full sm:w-auto text-sm font-semibold disabled:bg-zinc-400 disabled:text-zinc-800/60"
                type="button" [disabled]="deliveryMethod=='' " (click)="confirmAction()">{{txtConfirmButton}}</button>
        </div>
        }


        <button
            class="absolute top-2 right-2 dark:text-dark-khaki-50  text-medium_purple hover:dark:text-zinc-400 hover:text-vivid-royal-950"
            (click)="cancelAction()">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-6 h-6"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>
        </button>
    </div>
</div>